import { render } from "./ButtonUp.vue?vue&type=template&id=160ba845&scoped=true"
import script from "./ButtonUp.vue?vue&type=script&lang=js"
export * from "./ButtonUp.vue?vue&type=script&lang=js"

import "./ButtonUp.vue?vue&type=style&index=0&id=160ba845&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-160ba845"]])

export default __exports__